import React from 'react';import PropTypes from 'prop-types';
import classnames from 'classnames';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { actions, selectors } from '../../../../../modules/customer/profile/hardwareProducts';
import { SubscriptionElement, ProductItem } from '.';
import { Panel } from 'react-bootstrap';
import LoadingPanel from '../../../../components/LoadingPanel';
import ActionButton from '../../../../components/ActionButton';

const getFinancialStatusClass = (financeOption, isToCancel) => classnames('icon', 'financialStatus center', {
    'sold': financeOption === "Sold",
    'rent': financeOption === "Rent",
    'active': isToCancel === false,
    'no-active': isToCancel === true
});

const getProductIconClass = isToCancel => classnames('icon', 'productIcon', {
    'active': isToCancel === false,
    'no-active': isToCancel === true
});

const getCancelationIcon = isToCancel => {
    if (isToCancel) {
        return "/icons/prod_subsc/restore_ic.svg"
    }
    return "/icons/prod_subsc/cancel_ic.svg"
};

const shouldShowFirmareVersion = subscription =>  isSmartBox2TechnicalProduct(subscription.id) && !subscription.isLoadingSmb2FirmwareVersion;
const isSmartBox2TechnicalProduct = technicalProductid => selectors.smartBox2TechnicalIds.indexOf(technicalProductid) > -1;


const HardwareProductsTable = ({ hardwareProductsList, getHardwareProductDetails, getSmb2FirmwareDetails, editMode = false, toggleProductToCancelFlag, className, props }) => {
    const productTableClass = classnames('productTable', className);
    const hasHardwareProducts = hardwareProductsList && hardwareProductsList.length > 0;
    return (
        <div className={productTableClass}>
            <table>
                <thead>
                    <tr className="contentRow">
                        <th className="col-xs-6 fontSizeBase">Utstyr</th>
                        <th className="col-xs-2 fontSizeSmall">Status</th>
                        <th className="col-xs-2 fontSizeSmall">Abonnement</th>
                        <th className="col-xs-2"></th>
                    </tr>
                </thead>
                <tbody>
                    {hasHardwareProducts && hardwareProductsList.map((subscription, i) => {
                        let financialStatusClass = getFinancialStatusClass(subscription.financeOption, subscription.isToCancel);
                        let productIconClass = getProductIconClass(subscription.isToCancel);
                        let cancelIcon = getCancelationIcon(subscription.isToCancel);
                        return (
                            <tr key={i} className="contentRow">
                                <td className="col-xs-1">
                                    <div className={productIconClass} />
                                </td>
                                <td className="productBoxContent text-active accentedText">
                                    <Panel header={<div><ProductItem subscription={subscription} /></div>}
                                        eventKey="1"
                                        collapsible={true}
                                        onSelect={e => {
                                            if (!subscription.firstPurchaseDate && subscription.serialNumber.trim() !== ""){
                                                getHardwareProductDetails(subscription.commercialProductAgreementDetailId, subscription.serialNumber)
                                                if(isSmartBox2TechnicalProduct(subscription.id))
                                                    getSmb2FirmwareDetails(subscription.serialNumber)
                                            }
                                        }}>
                                        {
                                            !subscription.isLoadingWarranty &&
                                            <div className="col-xs-12 warranty-panel">
                                                <div className="row">
                                                    <div className="col-xs-6">garanti til:</div>
                                                    <div className="col-xs-6"><span className="warranty">{subscription.warrantyDate}</span></div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-xs-6">første kjøpsdato:</div>
                                                    <div className="col-xs-6">{subscription.firstPurchaseDate}</div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-xs-6">forhandler:</div>
                                                    <div className="col-xs-6">{subscription.guaranteeResponsibleName}</div>
                                                </div>
                                                {
                                                    shouldShowFirmareVersion(subscription) &&
                                                        <div className="row">
                                                            <div className="col-xs-6">programvare:</div>
                                                            <div className="col-xs-6">{subscription.smb2FirmwareVersion}</div>
                                                        </div>
                                                }
                                            </div>
                                        }
                                        {
                                            subscription.isLoadingWarranty && subscription.serialNumber.trim() !== "" &&
                                            <LoadingPanel />
                                        }
                                    </Panel>
                                </td>
                                <td className="col-xs-2 center text-center">
                                    <ul className="subscriptionList">                                    
                                    <li>
                                        {subscription.financeOption} hardware
                                    </li>
                                    <li>
                                        {subscription.deviceStatus}
                                    </li>
                                    <li>
                                        {subscription.status}
                                    </li>
                                    </ul>
                                </td>
                                <td className="col-xs-2">
                                    {subscription.linkedSubscriptions !== undefined
                                        && subscription.linkedSubscriptions !== null
                                        && subscription.linkedSubscriptions.length > 0              
                                        && <SubscriptionElement subscriptionlist={subscription.linkedSubscriptions} />
                                    }

                                </td>        
                                {!editMode &&
                                    <td className="col-xs-2"></td>
                                }                        
                                {editMode && 
                                    <td className="col-xs-2 text-right">
                                        {subscription.financeOption === "Sold" && subscription.isToCancel &&
                                            <ActionButton icon="cross" 
                                                className="red"
                                                action={toggleProductToCancelFlag.bind(undefined, subscription.commercialProductAgreementDetailId)}
                                                title="Valgt" />      
                                        }
                                        {subscription.financeOption === "Sold" && !subscription.isToCancel &&
                                            <ActionButton icon="cross" 
                                                action={toggleProductToCancelFlag.bind(undefined, subscription.commercialProductAgreementDetailId)}
                                                title="Valg" />      
                                        }
                                    </td>
                                }
                            </tr>
                        )
                    })
                    }
                    {!hasHardwareProducts &&
                            <tr>
                                <td>
                                    <div className="col-xs-12 fontSizeBase ">Ingen produkter</div>
                                </td>
                            </tr>
                    }
                </tbody>
            </table>
        </div>
    );
};

const mapDispatchToProps = (dispatch, props) => ({
    toggleProductToCancelFlag: (agreementDetailId) => dispatch(actions.toggleProductToCancelFlag(agreementDetailId)),
    getHardwareProductDetails: (productId, serial) => dispatch(actions.getHardwareProductDetails(productId, serial)),
    getSmb2FirmwareDetails: (serial) => dispatch(actions.getHardwareProductSmb2FirmwareVersion(serial))
});

export default connect(null, mapDispatchToProps)(HardwareProductsTable);